import styled from "react-emotion"
import PropTypes from "prop-types"

const Float = styled("span")`
    display: inline-block;
    position: absolute;
    right: ${props => (props.right ? "0px" : "unset")};
    left: ${props => (props.left ? "0px" : "unset")};
    top: ${props => (props.top ? "0px" : "unset")};
    bottom: ${props => (props.bottom ? "0px" : "unset")};
`

Float.propTypes = {
    right: PropTypes.boolean,
    left: PropTypes.boolean,
    top: PropTypes.boolean,
    bottom: PropTypes.boolean,
}

Float.displayName = "Float"
export default Float



// WEBPACK FOOTER //
// ./src/ui/components/Float.js